"use client";

import * as stylex from "@stylexjs/stylex";
import type { Ref, ReactNode } from "react";
import { StepBadge } from "./onboarding-step-badge";
import { styles } from "../onboarding.styles";
import { steps } from "../onboarding-steps";

export function StepRow({
  n,
  done,
  animateIn,
  rowRef,
  children,
}: Readonly<{
  n: number;
  done: boolean;
  animateIn: boolean;
  rowRef?: Ref<HTMLLIElement>;
  children: ReactNode;
}>) {
  return (
    <li
      ref={rowRef}
      {...stylex.props(
        styles.row,
        !done && styles.activeRow,
        animateIn && styles.enter,
      )}
    >
      <span
        {...stylex.props(styles.hidden)}
      >{`Step ${n} of ${steps.length}, ${done ? "done" : "in progress"}.`}</span>
      <StepBadge done={done} landing={animateIn} />
      <div {...stylex.props(styles.rowBody)}>{children}</div>
    </li>
  );
}
